import { render, staticRenderFns } from "./personalCard.vue?vue&type=template&id=4251620b&scoped=true"
import script from "./personalCard.vue?vue&type=script&lang=js"
export * from "./personalCard.vue?vue&type=script&lang=js"
import style0 from "./personalCard.vue?vue&type=style&index=0&id=4251620b&prod&scoped=true&lang=scss"
import style1 from "./personalCard.vue?vue&type=style&index=1&id=4251620b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251620b",
  null
  
)

export default component.exports